module.exports = __webpack_public_path__ + "static/media/wiki.57384017.svg";